import React, { useEffect } from 'react';
import { ACCESS_TO_PROD_KEY_PASS } from '../../../constants/vpool';
import { sha512 } from '../../../services/utilsService';

export default function PasswordPromt() {
  const handlePass = async () => {
    let isValid = false;
    const msg = 'Enter Password';
    const input = prompt(msg);
    const shaResult = await sha512(input);
    if (shaResult === ACCESS_TO_PROD_KEY_PASS) {
      isValid = true;
    } else handlePass();
  };

  useEffect(() => {
    setTimeout(() => {
      handlePass();
    }, 1500);
  }, []);
  return <></>;
}
